<template>
  <Row>
    <Col span="24">
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp"> 发布时间：2022-07-07 </span>
        </div>
        <div class="div_img01" v-for="(item, index) in img" :key="index">
          <span
            v-if="item.sp !== ''"
            :src="item.sp"
            style="
              font-size: 17px;
              font-weight: bold;
              color: #70a9f8;
              line-height: 34px;
            "
            >{{ item.sp }}</span
          >
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
          <img
            v-if="item.imgUrl02 !== ''"
            :src="item.imgUrl02"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl03 !== ''"
            :src="item.imgUrl03"
            alt="暂无照片"
          />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title: "热烈欢迎南阳市、驻马店市调研团队莅临智慧岛及南秀科技参观指导！",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsEight/01.jpg",
          imgUrl02: "",
          imgUrl03: "",
          p: "为贯彻落实智慧岛建设推进会会议精神，加快推动南阳市和驻马店市智慧岛建设工作，打造双创实际版，7月1日上午，南阳高新区党工委副书记、管委会主任党俊伟和驻马店市发展改革委副主任分别带领调研团队到智慧岛大厦开展调研工作。",
        },
        {
          imgUrl: "../../../static/img/News/NewsEight/02.jpg",
          imgUrl02: "../../../static/img/News/NewsEight/03.jpg",
          imgUrl03: "../../../static/img/News/NewsEight/04.jpg",
          p: "领导们参观了南秀科技展台，公司业务经理魏云飞向领导们详细介绍了南秀科技的发展历程、运营模式以及经营范围内的科技型产品。",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 100%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}

.div_img01 img {
  width: 96%;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsEight.vue